import React, { useState, useEffect } from "react";
import { Users, Loader2 } from "lucide-react";
import { academicService } from "../../services/academicService";

export const SectionManagementPage: React.FC = () => {
  const [sections, setSections] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDivisions();
  }, []);

  const fetchDivisions = async () => {
    try {
      const data = await academicService.getDivisions();
      setSections(data.results || data || []);
    } catch {
      setSections([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-5 bg-slate-900/90 border border-slate-800 rounded-xl shadow-md text-xs font-sans space-y-4">
      <div className="flex items-center justify-between pb-3 border-b border-slate-800">
        <div className="flex items-center gap-2">
          <Users className="w-5 h-5 text-indigo-400" />
          <h2 className="text-base font-bold text-slate-100">Section Allocation & Class Teacher Management</h2>
        </div>
      </div>

      {loading ? (
        <div className="p-8 text-center text-slate-400 text-xs flex items-center justify-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin text-indigo-400" /> Loading Sections...
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {sections.map((sec) => (
            <div key={sec.id} className="p-4 bg-slate-950/90 border border-slate-800 rounded-xl space-y-2 font-mono">
              <div className="flex items-center justify-between">
                <span className="text-[10px] font-bold text-indigo-400 bg-indigo-950 px-2 py-0.5 rounded border border-indigo-900">
                  Section {sec.name || sec.code}
                </span>
              </div>
              <h3 className="font-bold text-slate-100 text-sm font-sans">{sec.batch_name || "Academic Batch"}</h3>
            </div>
          ))}
          {sections.length === 0 && (
            <div className="md:col-span-2 p-8 text-center text-slate-500 font-sans border border-slate-800 rounded-xl bg-slate-950">
              No class sections or division allocations created yet.
            </div>
          )}
        </div>
      )}
    </div>
  );
};
